import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import CustomStylesSheet from '@cred/custom-styles-sheet'
import Theme from './Theme'

import { ThemeContext } from './useStyles'

const ThemeProvider = ({ themeName, customStyles, children }) => {
  const { current } = useRef(Date.now())
  const customStylesWrapperClassName = customStyles ? `custom_styles_${current}` : undefined

  return (
    <Theme themeName={themeName} className={customStylesWrapperClassName}>
      <ThemeContext.Provider value={themeName}>{children}</ThemeContext.Provider>
      {customStyles && (
        <CustomStylesSheet styles={customStyles} className={customStylesWrapperClassName} />
      )}
    </Theme>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
    PropTypes.func
  ]).isRequired,
  themeName: PropTypes.string,
  customStyles: PropTypes.object
}

export default ThemeProvider
